
import { defineComponent, ref, computed, reactive, watch, getCurrentInstance } from "vue";
import axios from "@/axios-instance"
import { hideModal } from "@/core/helpers/dom";
import Swal from "sweetalert2/dist/sweetalert2.js";

export default defineComponent({
  name: "logs",

  emits: ["changeEdit","submitForm","validateFail","beforeSave"],
  props: {
    dataCustomer: { type: Object, required: true },
    cardClasses: String,
    isAddProfile: { type: Boolean},
    isEdit: { type: Boolean },
    // Tiêu đề section hiển thị bên trong card (chỉ hiện khi truyền vào — vd trang Thêm ứng viên gộp 1 form)
    sectionTitle: { type: String, default: '' },
    // Ứng viên CHỈ có hồ sơ liên thông (mọi hồ sơ đều idAdMethod=9) -> ẩn 2 bảng điểm THPT.
    // Tính ở cha vì chỉ cha (candidateListDetail) mới biết danh sách TOÀN BỘ hồ sơ.
    isOnlyArticulation: { type: Boolean, default: false },
    // Danh sách hồ sơ trúng tuyển của ứng viên (winner) — chỉ dùng để biết hồ sơ LIÊN THÔNG
    // đã trúng tuyển hay chưa, vì trúng tuyển rồi thì hồ sơ xét tuyển gốc bị KHÓA, không mở sửa được nữa.
    dataApplicant: { type: Array, default: () => [] as any[] },
  },
  data() {
      return {
        schoolProcess10DistrictOption: [] ,//as formatSelect[],
        schoolProcess11DistrictOption: [] ,//as formatSelect[],
        schoolProcess12DistrictOption: [] ,//as formatSelect[],
        schoolProcess10SchoolNameOption: [] ,//as formatSelect[],
        schoolProcess11SchoolNameOption: [] ,//as formatSelect[],
        schoolProcess12SchoolNameOption: [] ,//as formatSelect[],
        dataProvinceForSchool: [],
        // "Lớp 11 & 10 giống lớp 12": mặc định BẬT ở trang Thêm ứng viên (đa số học 1 trường 3 năm);
        // trang chi tiết mặc định TẮT (tránh ghi đè dữ liệu thật khi chỉnh lớp 12)
        sameAsClass12: this.isAddProfile === true,
      }
  },
  methods: {
    loadDefaultData() {
      // HỦY = REVERT thật (convention drawer-cancel-revert): trước đây chỉ thoát edit — điểm mục 5/6
      // nhập qua drawer vẫn dính ở chế độ xem (nhìn như đã lưu) và bị LƯU KÉ lần Lưu sau vì dirty flag còn bật.
      const fd: any = this.formData
      Object.keys(fd).forEach((k: string) => delete fd[k])
      Object.assign(fd, JSON.parse(JSON.stringify(this.dataCustomer)))
      // khối bằng TC/CĐ luôn render (d-none) -> phải có object để bind
      if (!fd._arpros) fd._arpros = {}
      if (!fd._arpros.intermediate) fd._arpros.intermediate = {}
      ;(this as any).transcriptDirty = false
      ;(this as any).gradScoreDirty = false
      this.sameAsClass12 = this.isAddProfile === true
      if (!this.isAddProfile) this.loadInitialSchools() // option trường khớp lại tỉnh gốc
      this.$emit("changeEdit", {isCanceled:true});
    },
    //------------------10-----------------------
    async schoolProcessProvinceChange(id:string) {
      let provinceSelect:({code:string}) = this.dataProvinceForSchool.filter((item:{id:string,name:string}) => item.id == id)[0]
      this.formData.class10DistrictId = ""
      this.formData.class10SchoolId = ""
      this.schoolProcess10SchoolNameOption = []
      if(provinceSelect) {
        await this.loadProvinceSchools(10, provinceSelect.code)
      }
      if(!this.formData.class11ProvinceId || this.formData.class11ProvinceId == "") {
        await this.schoolProcess11ProvinceChange(id)
        this.formData.class11ProvinceId = id
      }
      if(!this.formData.class12ProvinceId || this.formData.class12ProvinceId == "") {
        await this.schoolProcess12ProvinceChange(id)
        this.formData.class12ProvinceId = id
      }
    },
    async schoolProcessDistrictChange(id:string) {
      let districtSelect:({code:string,provinceCode:string}) = this.schoolProcess10DistrictOption.filter((item:{id:string,name:string}) => item.id === id)[0]
      if(districtSelect) {
        this.schoolProcess10SchoolNameOption = await this.getSchools(districtSelect.code,districtSelect.provinceCode)
      }
      this.formData.class10SchoolId = ""
      if(!this.formData.class11DistrictId || this.formData.class11DistrictId == "") {
        await this.schoolProcess11DistrictChange(id)
        this.formData.class11DistrictId = id
      }
      if(!this.formData.class12DistrictId || this.formData.class12DistrictId == "") {
        await this.schoolProcess12DistrictChange(id)
        this.formData.class12DistrictId = id
      }
    },
    async schoolProcessSchoolNameChange(id:string) {
      this.formData.class10SchoolId = id
      this.deriveDistrict(10, id)
      if(!this.formData.class11SchoolId || this.formData.class11SchoolId == "") {
        this.formData.class11SchoolId = id
        this.deriveDistrict(11, id)
      }
      if(!this.formData.class12SchoolId || this.formData.class12SchoolId == "") {
        this.formData.class12SchoolId = id
        this.deriveDistrict(12, id)
      }
      this.formData.priorityArea = this.autoArea()
    },
    //-------------------end10------------------
    //-------------------11------------------
    async schoolProcess11ProvinceChange(id:string) {
      let provinceSelect:({code:string}) = this.dataProvinceForSchool.filter((item:{id:string,name:string}) => item.id == id)[0]
      this.formData.class11DistrictId = ""
      this.formData.class11SchoolId = ""
      this.schoolProcess11SchoolNameOption = []
      if(provinceSelect) {
        await this.loadProvinceSchools(11, provinceSelect.code)
      }
    },
     async schoolProcess11DistrictChange(id:string) {
      let districtSelect:({code:string,provinceCode:string}) = this.schoolProcess11DistrictOption.filter((item:{id:string,name:string}) => item.id === id)[0]
      this.formData.class11SchoolId = ""
      if(districtSelect) {
        this.schoolProcess11SchoolNameOption = await this.getSchools(districtSelect.code,districtSelect.provinceCode)
      }
    },
    async schoolProcess11SchoolNameChange(id:string) {
      this.formData.class11SchoolId = id
      this.deriveDistrict(11, id)
      this.formData.priorityArea = this.autoArea()
    },
    //-------------------end11------------------
    //-------------------12------------------
    async schoolProcess12ProvinceChange(id:string) {
      this.formData.class12DistrictId = ""
      this.formData.class12SchoolId = ""
      this.schoolProcess12SchoolNameOption = []
      let provinceSelect:({code:string}) = this.dataProvinceForSchool.filter((item:{id:string,name:string}) => item.id == id)[0]
      if(provinceSelect) {
        await this.loadProvinceSchools(12, provinceSelect.code)
      }
      this.applySameAsClass12()
    },
    async schoolProcess12DistrictChange(id:string) {
      this.formData.class12SchoolId = ""
      let districtSelect:({code:string,provinceCode:string}) = this.schoolProcess12DistrictOption.filter((item:{id:string,name:string}) => item.id === id)[0]
      if(districtSelect) {
        this.schoolProcess12SchoolNameOption = await this.getSchools(districtSelect.code,districtSelect.provinceCode)
      }
    },
    async schoolProcess12SchoolNameChange(id:string) {
      this.formData.class12SchoolId = id
      this.deriveDistrict(12, id)
      this.applySameAsClass12()
      this.formData.priorityArea = this.autoArea()
    },
    //-------------------end12------------------
    // Checkbox "Lớp 11 và lớp 10 giống lớp 12": copy tỉnh + danh sách trường + trường của lớp 12 sang 11/10.
    // Gọi khi: tick checkbox, đổi tỉnh lớp 12, chọn trường lớp 12. Lớp 12 đổi tỉnh (trường về trống) -> 11/10 cũng về trống theo.
    applySameAsClass12() {
      if (!this.sameAsClass12 || !this.formData.class12ProvinceId) return
      this.formData.class11ProvinceId = this.formData.class12ProvinceId
      this.formData.class10ProvinceId = this.formData.class12ProvinceId
      this.schoolProcess11SchoolNameOption = [...this.schoolProcess12SchoolNameOption]
      this.schoolProcess10SchoolNameOption = [...this.schoolProcess12SchoolNameOption]
      this.formData.class11SchoolId = this.formData.class12SchoolId
      this.formData.class10SchoolId = this.formData.class12SchoolId
      if (this.formData.class12SchoolId) {
        this.deriveDistrict(11, this.formData.class12SchoolId)
        this.deriveDistrict(10, this.formData.class12SchoolId)
      } else {
        this.formData.class11DistrictId = ""
        this.formData.class10DistrictId = ""
      }
      this.formData.priorityArea = this.autoArea()
    },
    autoArea() {
      // Nạp Khu vực ưu tiên theo trường: ưu tiên lớp 12 (năm cuối); nếu đủ 3 năm thì lấy KV đa số.
      const areaOf = (opt:any, id:any) => (id ? opt?.find((i:any) => i.id == id)?.area : '')
      const a10 = areaOf(this.schoolProcess10SchoolNameOption, this.formData.class10SchoolId)
      const a11 = areaOf(this.schoolProcess11SchoolNameOption, this.formData.class11SchoolId)
      const a12 = areaOf(this.schoolProcess12SchoolNameOption, this.formData.class12SchoolId)
      if (a10 && a11 && a12) {
        if (a10 == a11 || a10 == a12) return a10
        if (a11 == a12) return a11
        return a12
      }
      // Chưa đủ 3 năm → nạp theo trường gần nhất có dữ liệu (12 → 11 → 10)
      return a12 || a11 || a10 || ''
    },
    async getDistrictForSchool(code:string) {
      let arrTemp = []
      await axios.get(`/district/?pvcode=${code}`)
      .then(( {data} ) => {
        arrTemp = data
      })
      .catch(({ response }) => {
        console.log('err',response)
      });
      return arrTemp
    },
    async getSchools(dtcode:string,pvcode:string) {
      let arrTemp = []
      await axios.get(`/school/?dtcode=${dtcode}&pvcode=${pvcode}`)
      .then(( {data} ) => {
        arrTemp = data
      })
      .catch(({ response }) => {
        console.log('err',response)
      });
      return arrTemp
    },
    // Lấy TẤT CẢ trường trong 1 tỉnh (không lọc theo huyện) -> để chọn trường 1 bước, gõ tìm theo tên/huyện.
    async getSchoolsByProvince(pvcode:string) {
      let arrTemp = []
      await axios.get(`/school/?pvcode=${pvcode}`)
      .then(( {data} ) => { arrTemp = data })
      .catch(() => {});
      return arrTemp
    },
    // Suy class{year}DistrictId từ trường đã chọn (school.districtCode -> district.id) để vẫn lưu đủ FK huyện 3 cấp.
    deriveDistrict(year:number, schoolId:string) {
      const school = (this[`schoolProcess${year}SchoolNameOption`] as any[]).find((i:any) => i.id == schoolId)
      if (school) {
        const d = (this[`schoolProcess${year}DistrictOption`] as any[]).find((x:any) => x.code == school.districtCode)
        this.formData[`class${year}DistrictId`] = d ? d.id : ""
      }
    },
    // Đổi Tỉnh -> nạp danh sách huyện (để map code->id) + TẤT CẢ trường trong tỉnh.
    async loadProvinceSchools(year:number, provinceCode:string) {
      this[`schoolProcess${year}DistrictOption`] = await this.getDistrictForSchool(provinceCode)
      this[`schoolProcess${year}SchoolNameOption`] = await this.getSchoolsByProvince(provinceCode)
    },
    async loadInitialSchools() {
      const years = [10, 11, 12];
      for (const year of years) {
        const provinceId = this.formData[`class${year}ProvinceId`];
        if (provinceId && provinceId !== "") {
          let provinceSelect = this.dataProvinceForSchool.find((item:any) => item.id == provinceId) as any;
          if (provinceSelect) {
            await this.loadProvinceSchools(year, provinceSelect.code);
          }
        }
      }
    },
  },
  watch: {
    'formData.class10ProvinceId': {
        handler: async function(newVal) {
            if(newVal && !this.isAddProfile && this.dataProvinceForSchool.length > 0) {
              await this.loadInitialSchools();
            }
        },
        immediate: true
    }
  },
  async mounted() {
    await axios.get('/province')
    .then(( {data} ) => {
      this.dataProvinceForSchool = data
    })
    .catch(({ response }) => {
      console.log('err',response)
    });

    if(!this.isAddProfile) {
      await this.loadInitialSchools();
    }
  },
  setup(props,{ emit }) {
    const { proxy } = getCurrentInstance() as any
    const formRef = ref<null | HTMLFormElement>(null);
    const addCustomerModalRef = ref<null | HTMLElement>(null);
    const localFormData = reactive({} as any)
    const formData = localFormData

    // Khối "Bằng tốt nghiệp TC/CĐ" bind thẳng vào formData._arpros. BE chỉ gắn _arpros khi ứng viên
    // là liên thông, mà khối lại ẩn/hiện bằng d-none (vẫn RENDER) -> thiếu object này là crash template.
    const _ensureArpro = (obj: any) => {
      if (!obj) { return }
      if (!obj._arpros) { obj._arpros = {} }
      // intermediate luôn render (ẩn bằng d-none) -> phải có object để v-model bind, kể cả khi
      // hồ sơ chưa tick "liên thông từ Trung cấp".
      if (!obj._arpros.intermediate) { obj._arpros.intermediate = {} }
    }

    // Initial sync
    Object.assign(localFormData, JSON.parse(JSON.stringify(props.dataCustomer)))
    _ensureArpro(localFormData)

    // Watch props.dataCustomer and synchronize localFormData
    watch(() => props.dataCustomer, (newVal) => {
      // Re-initialize localFormData while keeping reactivity
      Object.keys(localFormData).forEach(key => delete localFormData[key])
      Object.assign(localFormData, JSON.parse(JSON.stringify(newVal)))
      _ensureArpro(localFormData)

      proxy?.loadInitialSchools();
    }, { deep: true })

    // Ứng viên có hồ sơ LIÊN THÔNG -> hiện khối bằng TC/CĐ
    const isArticulationStudent = computed(() => !!localFormData.isarticulationprogram)
    // Chú thích thang điểm dạng CHUỖI (rỗng khi chưa chọn) — tránh v-if trong khối này.
    const arproGpaScaleHint = computed(() => {
      const _for = localFormData._arpros?.gpafor
      if (_for === 'gpa4') { return ' · thang 0 – 4' }
      if (_for === 'gpa10') { return ' · thang 0 – 10' }
      return ''
    })

    const arrPriorityArea = {
      "KV1": 0.75,
      "KV2NT": 0.5,
      "KV2": 0.25,
      "KV3": 0,
    }
    const arrPriorityObject = {
      "00": 0,
      "01": 2,
      "02": 2,
      "03": 2,
      "04": 2,
      "05": 1,
      "06": 1,
      "07": 1,
    }
    const sumPointPriority = computed(() => {
      let a:number = arrPriorityArea[formData.priorityArea]?arrPriorityArea[formData.priorityArea] : 0
      let b:number = arrPriorityObject[formData.priorityObject]?arrPriorityObject[formData.priorityObject] : 0
      return a + b
    })

    // ===== Bảng điểm học bạ THPT (transcript trên students) =====
    // Key môn = ĐÚNG key trong admission_forms.subjectthpt -> form hồ sơ PT2/9CR map thẳng không cần chuyển đổi.
    const transcriptSubjects = [
      { label: 'Toán', short: 'Toán', value: 'mathTHPT' },
      { label: 'Ngữ văn', short: 'Văn', value: 'literatureTHPT' },
      { label: 'Tiếng Anh', short: 'Anh', value: 'englishTHPT' },
      { label: 'Vật lý', short: 'Lý', value: 'physicsTHPT' },
      { label: 'Hóa học', short: 'Hóa', value: 'chemistryTHPT' },
      { label: 'Sinh học', short: 'Sinh', value: 'biologicalTHPT' },
      { label: 'Lịch sử', short: 'Sử', value: 'historyTHPT' },
      { label: 'Địa lý', short: 'Địa', value: 'geographyTHPT' },
      { label: 'GDCD', short: 'GDCD', value: 'civicEducationTHPT' },
      { label: 'Giáo dục kinh tế và pháp luật', short: 'KT&PL', value: 'economicsAndLawEducationTHPT' },
      { label: 'Tin học', short: 'Tin', value: 'informationTechnologyTHPT' },
      { label: 'Vẽ', short: 'Vẽ', value: 'artTHPT' },
      { label: 'Tiếng Pháp', short: 'Pháp', value: 'frenchTHPT' },
      //2 môn công nghệ theo file học bạ của Bộ 2026 (import điểm đổ vào đây; chưa thuộc tổ hợp xét tuyển nào)
      { label: 'Công nghệ công nghiệp', short: 'CNCN', value: 'industrialTechTHPT' },
      { label: 'Công nghệ nông nghiệp', short: 'CNNN', value: 'agriculturalTechTHPT' },
    ]
    const transcriptYears = [
      { key: 'c10', label: 'Lớp 10' },
      { key: 'c11', label: 'Lớp 11' },
      { key: 'c12', label: 'Lớp 12' },
    ]
    const showTranscriptDrawer = ref(false)
    // Enter = nhảy XUỐNG ô dưới cùng cột (nhập theo LỚP: hết môn của 1 lớp rồi sang cột lớp kế)
    const focusNextTranscriptInput = (e: any) => {
      const inputs = Array.from(document.querySelectorAll('.el-drawer .transcript-input input')) as HTMLInputElement[]
      const idx = inputs.indexOf(e.target)
      if (idx < 0) return
      const COLS = 3 // 3 cột năm; DOM xếp theo hàng (mỗi môn 3 ô)
      if (idx + COLS < inputs.length) {
        inputs[idx + COLS].focus() // xuống môn kế, cùng lớp
      } else {
        const col = idx % COLS
        if (col + 1 < COLS) inputs[col + 1].focus() // hết cột -> lên đầu cột lớp kế tiếp
      }
    }
    // true khi user THẬT SỰ sửa bảng điểm trong phiên — doSave chỉ gửi field transcript khi dirty
    // (chống lost-update: tab mở lâu PUT nguyên clone cũ đè transcript vừa được cập nhật nơi khác)
    const transcriptDirty = ref(false)
    // Khi ĐANG GÕ: lưu giá trị thô (không clamp/round mỗi phím — sẽ phá gõ "8.25"); chuẩn hoá ở @change (blur/Enter)
    const setTranscriptScore = (subjectKey: string, yearKey: string, val: any) => {
      transcriptDirty.value = true
      if (!formData.transcript || typeof formData.transcript !== 'object') formData.transcript = {}
      if (val === '' || val === null || val === undefined) {
        if (formData.transcript[subjectKey]) {
          delete formData.transcript[subjectKey][yearKey]
          if (Object.keys(formData.transcript[subjectKey]).length === 0) delete formData.transcript[subjectKey]
        }
        return
      }
      if (!formData.transcript[subjectKey]) formData.transcript[subjectKey] = {}
      formData.transcript[subjectKey][yearKey] = val
    }
    // Chuẩn hoá 1 ô khi rời ô/Enter: số 0-10, làm tròn 1 lẻ; không hợp lệ -> xoá
    const normalizeTranscriptScore = (subjectKey: string, yearKey: string) => {
      const rec = formData.transcript?.[subjectKey]
      if (!rec || rec[yearKey] === undefined) return
      let n = +rec[yearKey]
      if (rec[yearKey] === '' || isNaN(n)) {
        delete rec[yearKey]
        if (Object.keys(rec).length === 0) delete formData.transcript[subjectKey]
        return
      }
      if (n < 0) n = 0
      if (n > 10) n = 10
      rec[yearKey] = Math.round(n * 10) / 10
    }

    // ===== Bảng điểm thi TN THPT (graduationscore trên students) — 1 điểm/môn =====
    // Bộ môn KHỚP ĐÚNG 10 ô điểm đang hiển thị ở form hồ sơ PT1 (Pháp/Vẽ form đang ẩn — không đưa vào đây,
    // khác bộ 13 môn transcriptSubjects của học bạ); key = đúng tên field điểm PT1 -> map thẳng.
    const gradScoreSubjects = [
      { label: 'Toán', short: 'Toán', value: 'mathTHPT' },
      { label: 'Ngữ văn', short: 'Văn', value: 'literatureTHPT' },
      { label: 'Tiếng Anh', short: 'Anh', value: 'englishTHPT' },
      { label: 'Vật lý', short: 'Lý', value: 'physicsTHPT' },
      { label: 'Hóa học', short: 'Hóa', value: 'chemistryTHPT' },
      { label: 'Sinh học', short: 'Sinh', value: 'biologicalTHPT' },
      { label: 'Lịch sử', short: 'Sử', value: 'historyTHPT' },
      { label: 'Địa lý', short: 'Địa', value: 'geographyTHPT' },
      { label: 'Tin học', short: 'Tin', value: 'informationTechnologyTHPT' },
      { label: 'Giáo dục kinh tế và pháp luật', short: 'KT&PL', value: 'economicsAndLawEducationTHPT' },
    ]
    const showGradScoreDrawer = ref(false)
    // true khi user THẬT SỰ sửa trong phiên — doSave chỉ gửi field graduationscore khi dirty (chống lost-update)
    const gradScoreDirty = ref(false)
    const setGradScore = (subjectKey: string, val: any) => {
      gradScoreDirty.value = true
      if (!formData.graduationscore || typeof formData.graduationscore !== 'object') formData.graduationscore = {}
      if (val === '' || val === null || val === undefined) {
        delete formData.graduationscore[subjectKey]
        return
      }
      formData.graduationscore[subjectKey] = val
    }
    // Điểm thi làm tròn 2 lẻ (khác học bạ 1 lẻ — điểm thi TN có 8.25)
    const normalizeGradScore = (subjectKey: string) => {
      const rec = formData.graduationscore
      if (!rec || rec[subjectKey] === undefined) return
      let n = +rec[subjectKey]
      if (rec[subjectKey] === '' || isNaN(n)) {
        delete rec[subjectKey]
        return
      }
      if (n < 0) n = 0
      if (n > 10) n = 10
      rec[subjectKey] = Math.round(n * 100) / 100
    }
    const focusNextGradScoreInput = (e: any) => {
      const inputs = Array.from(document.querySelectorAll('.el-drawer .gradscore-input input')) as HTMLInputElement[]
      const idx = inputs.indexOf(e.target)
      if (idx >= 0 && idx + 1 < inputs.length) inputs[idx + 1].focus()
    }
    
    // Năm TN cho chọn: năm hiện tại (thi năm nay) trở về 15 năm trước
    const graduatedYearOptions = computed(() => {
      const y = new Date().getFullYear()
      return Array.from({ length: 16 }, (_, i) => String(y - i))
    })
    // Cần số hiệu bằng khi TN NĂM TRƯỚC (đã có năm TN + khác năm hiện tại)
    const needCertificate = computed(() => {
      const gy = Number(formData.graduatedYear)
      return !!gy && gy !== new Date().getFullYear()
    })

    // Hồ sơ LIÊN THÔNG đã trúng tuyển (winner idAdMethod=9 chưa hủy) -> hồ sơ xét tuyển gốc đã KHÓA.
    // Bấm "Mở hồ sơ liên thông để sửa" lúc này là đường cụt: sang bên đó cũng không sửa được.
    // Sau trúng tuyển, bản còn sửa là bản NHẬP HỌC (articulation_enrollment) ở trang Thủ tục nhập học.
    const arproWon = computed(() =>
      (props.dataApplicant as any[]).some((ap: any) => ap && ap.idAdMethod == 9 && ap.status != 'cancel')
    )
    //Một chuỗi duy nhất thay vì 2 nhánh v-if: khối LearningInfor đã từng vỡ patch Vue (insertBefore null)
    //vì thêm v-if, nên phần động ở đây giữ dạng interpolation.
    const arproEditNote = computed(() => arproWon.value
      ? 'Thông tin bằng Trung cấp/Cao đẳng của hồ sơ xét tuyển liên thông — chỉ xem tại đây. Hồ sơ đã trúng tuyển nên bản xét tuyển gốc đã khóa: cần sửa, vào hồ sơ nhập học của thí sinh (mục Bằng Trung cấp/Cao đẳng).'
      : 'Thông tin bằng Trung cấp/Cao đẳng của hồ sơ xét tuyển liên thông — chỉ xem tại đây. Cần sửa, mở hồ sơ liên thông.')

    // BỎ validator chặn lưu (admin được phép lưu hồ sơ còn thiếu). Thay bằng info "đang thiếu thông tin quan trọng".
    const rules = ref({})
    const missingImportant = computed(() => {
      const m:string[] = []
      const _ltOnly = props.isOnlyArticulation
      //Ứng viên CHỈ có hồ sơ liên thông: KHÔNG đòi trường lớp 10/11 (chúng phục vụ học bạ 3 năm của PT2).
      //Vẫn đòi lớp 12 + số hiệu bằng THPT — đây là yêu cầu nghiệp vụ đã chốt cho hệ liên thông.
      if (!_ltOnly && !formData.class10SchoolId) m.push('Trường lớp 10')
      if (!_ltOnly && !formData.class11SchoolId) m.push('Trường lớp 11')
      if (!formData.class12SchoolId) m.push('Trường lớp 12')
      if (!formData.graduatedYear) m.push('Năm tốt nghiệp')
      //Ưu tiên chỉ áp dụng cho hệ chính quy; với ứng viên chỉ có hồ sơ LT thì 2 ô này đã bị ẩn
      //-> không được đòi, kẻo báo thiếu một thứ người dùng không nhìn thấy để điền.
      if (!_ltOnly && !formData.priorityObject) m.push('Đối tượng ưu tiên')
      if (!_ltOnly && !formData.priorityArea) m.push('Khu vực ưu tiên')
      //TN năm trước (đã có bằng) thì phải có số hiệu bằng — TN năm nay chưa có bằng, không đòi
      if (needCertificate.value && !formData.certificateNumber) m.push('Số hiệu bằng tốt nghiệp')
      //Bằng TC/CĐ là ĐIỀU KIỆN DỰ TUYỂN của hệ liên thông -> thiếu phải báo, ngang hàng với thiếu lớp 12.
      //Bộ trường tối thiểu khớp với cổng đăng ký công khai (trường TN / hệ / năm TN / điểm).
      if (_ltOnly) {
        const _arp: any = formData._arpros || {}
        if (!_arp.graduationschool) m.push('Trường tốt nghiệp TC/CĐ')
        if (!_arp.graduationsys) m.push('Hệ đào tạo TC/CĐ')
        if (!_arp.graduationyear) m.push('Năm tốt nghiệp TC/CĐ')
        if (_arp.gpa === undefined || _arp.gpa === null || _arp.gpa === '') m.push('Điểm trung bình TC/CĐ')
      }
      return m
    })
    // Suy field dẫn xuất (tên trường theo id) NGAY VÀO formData, để trang cha trộn sửa đổi 2 tab
    // trước khi lưu (xem saveEditTab ở candidateListDetail).
    const applyDerived = () => {
      const f: any = formData
      ;[10, 11, 12].forEach((c) => {
        const id = f[`class${c}SchoolId`]
        if (!id) return
        const opt = (proxy as any)?.[`schoolProcess${c}SchoolNameOption`]
        const school = opt?.find((i: any) => i.id == id)
        if (school) f[`class${c}SchoolName`] = school.name
      })
    }
    // Chống double-click nút Lưu: bấm nhiều lần trước khi request xong -> bắn nhiều PUT + nhiều popup
    // "Lưu thành công". Khoá trong lúc đang lưu, mở lại khi xong (thành công/lỗi).
    const saving = ref(false)
    const submit = async () => {
      if (!formRef.value) {
        return;
      }
      if (saving.value) { return } // đang lưu -> bỏ qua các cú bấm tiếp theo
      saving.value = true;
      // Nút "Lưu thay đổi" NẰM TRONG form này gọi thẳng submit(), KHÔNG đi qua saveEditTab của trang cha
      // -> xin trang cha trộn sửa đổi của tab kia vào formData trước, nếu không sẽ mất/ghi đè field tab kia.
      // (emit đồng bộ nên trang cha xử lý xong mới chạy tiếp)
      if (!props.isAddProfile) emit('beforeSave', 'learning')
      // Logic lưu: tạo mới thì emit dữ liệu; sửa thì gọi API cập nhật.
      const doSave = async () => {
          let checkPriorityScore = false
          let dataPriorityScore = {}
          if(sumPointPriority.value != formData.priorityScore) {
            dataPriorityScore = {
              "idStudent": formData.id,
              "newPriorityScore": sumPointPriority.value,
              "oldPriorityScore": JSON.parse(JSON.stringify(formData.priorityScore))
            }
            formData.priorityScore = sumPointPriority.value
            checkPriorityScore = true
          }
          if(props.isAddProfile) {
            emit("submitForm", {isValid : true, learnData: JSON.parse(JSON.stringify(formData))});
            saving.value = false // trang cha (Thêm ứng viên) tự xử lý tiếp -> mở khoá lại
          }
          else {
            let tempData = JSON.parse(JSON.stringify(formData))
            const cleanEmpty = (obj) => {
              Object.keys(obj).forEach(key => {
                if (obj[key] === "") {
                  delete obj[key];
                } else if (obj[key] && typeof obj[key] === 'object' && !Array.isArray(obj[key])) {
                  cleanEmpty(obj[key]);
                }
              });
            };
            cleanEmpty(tempData);
            tempData.gender = tempData.gender?"1":"0"
            delete tempData.verifiedDate
            delete tempData.highschoolGraduation
            delete tempData.status
            delete tempData.updatedAt
            delete tempData.createdAt
            // Field THUỘC tab Thông tin cá nhân: chỉ gửi khi THỰC SỰ đổi (được trộn sang từ tab kia).
            // Nếu không, clone cũ của tab Học tập sẽ ĐÈ giá trị cũ (thường là null) lên dữ liệu vừa nhập
            // bên tab Cá nhân — cleanEmpty chỉ bỏ chuỗi rỗng, KHÔNG bỏ null nên null vẫn bị gửi đi.
            const PERSONAL_ONLY = [
              // định danh: THIẾU idCard ở đây từng làm tab Học tập ghi đè ngược CCCD vừa sửa bên tab Cá nhân
              'idCard', 'fullName', 'email', 'phone',
              'ethnic', 'religion', 'nationality', 'birthPlace', 'dateOfIssue', 'issuePlace', 'taxNumber', 'objectTax',
              'contactAddress', 'contactProvinceId', 'contactWardId',
              'newContactProvinceCode', 'newContactProvinceName', 'newContactWardCode', 'newContactWardName',
              'prAddress', 'prProvinceId', 'prWardId',
              'newPrProvinceCode', 'newPrProvinceName', 'newPrWardCode', 'newPrWardName',
            ]
            PERSONAL_ONLY.forEach((k) => {
              if (JSON.stringify(tempData[k]) === JSON.stringify((props.dataCustomer as any)?.[k])) delete tempData[k]
            })
            // Bằng TC/CĐ (articulationprograms) chỉ XEM ở tab này — sửa qua form hồ sơ liên thông (link bên dưới khối).
            // Tách khỏi payload student; KHÔNG ghi lại từ đây. (Trước đây có POST re-ghi nhưng cổng dirty lệch
            // gần như luôn true -> mỗi lần Lưu tab đều đè lại hồ sơ LT bằng bản có thể cũ hơn -> bỏ hẳn.)
            delete tempData._arpros

            // KHÔNG đụng bảng điểm trong phiên -> không gửi field transcript
            // (tránh clone cũ đè transcript vừa được cập nhật ở nơi khác — form hồ sơ write-back)
            if (!transcriptDirty.value) delete tempData.transcript
            // Tương tự với bảng điểm thi TN THPT (hồ sơ PT1 cũng write-back về field này)
            if (!gradScoreDirty.value) delete tempData.graduationscore

            // Map class 10 school name
            if (tempData.class10SchoolId) {
              const school = proxy?.schoolProcess10SchoolNameOption?.find(i => i.id == tempData.class10SchoolId)
              if (school) {
                tempData.class10SchoolName = school.name
              }
            }

            // Map class 11 school name
            if (tempData.class11SchoolId) {
              const school = proxy?.schoolProcess11SchoolNameOption?.find(i => i.id == tempData.class11SchoolId)
              if (school) {
                tempData.class11SchoolName = school.name
              }
            }

            // Map class 12 school name
            if (tempData.class12SchoolId) {
              const school = proxy?.schoolProcess12SchoolNameOption?.find(i => i.id == tempData.class12SchoolId)
              if (school) {
                tempData.class12SchoolName = school.name
              }
            }

            await axios.put(`/admission/student/${formData.id}`, tempData)
            .then(async ( {data} ) => {
              transcriptDirty.value = false
              gradScoreDirty.value = false
              if(checkPriorityScore) {
                axios.put(`/admission/student/update/priorityscore`, dataPriorityScore)
                checkPriorityScore = false
              }
              axios.post(`/admission/register/generate/${tempData.id}`)
              emit("changeEdit", {isConfirmed : true});
              Swal.fire({
                  text: "Lưu thành công",
                  icon: "success",
                  timer: 2000,
                  timerProgressBar: true,
                  buttonsStyling: false,
                  confirmButtonText: "Đóng",
                  customClass: {
                      confirmButton: "btn btn-primary",
                  },
              }).then(() => {
                  hideModal(addCustomerModalRef.value);
              });              
            })
            .catch(({ response }) => {
              console.log('err',response)
              Swal.fire({
                  text: response.data?.errorMessage || "Có lỗi trong quá trình thực hiện.",
                  icon: "error",
                  buttonsStyling: false,
                  confirmButtonText: "Làm mới lại trang",
                  customClass: {
                      confirmButton: "btn btn-primary",
                  },
              }).then(() => {
                  location.reload()
              });
            })
            .finally(() => { saving.value = false }); // mở khoá nút Lưu khi request xong (dù thành công/lỗi)
          }
      };

      if (props.isAddProfile) {
        // Trang Thêm ứng viên: CHO LƯU THIẾU — banner "Còn thiếu" đã cảnh báo;
        // validate chỉ để tô đỏ field, KHÔNG chặn lưu.
        formRef.value.validate(async () => {
          try { await doSave(); } catch (e) { saving.value = false } // lỗi đồng bộ -> mở khoá, không kẹt nút
        });
      } else {
        // Sửa hồ sơ: cho phép lưu dù thiếu field bắt buộc (banner "Còn thiếu" chỉ cảnh báo).
        try { await doSave(); } catch (e) { saving.value = false }
      }
    };
    return {
      formData,
      saving,
      sumPointPriority,
      missingImportant,
      arproWon,
      arproEditNote,
      graduatedYearOptions,
      needCertificate,
      arrPriorityArea,
      arrPriorityObject,
      rules,
      addCustomerModalRef,
      formRef,
      submit,
      applyDerived,
      transcriptDirty,
      gradScoreDirty,
      isArticulationStudent,
      arproGpaScaleHint,
      transcriptSubjects,
      transcriptYears,
      setTranscriptScore,
      normalizeTranscriptScore,
      showTranscriptDrawer,
      focusNextTranscriptInput,
      gradScoreSubjects,
      showGradScoreDrawer,
      setGradScore,
      normalizeGradScore,
      focusNextGradScoreInput,
    };
  },
});
